<template>
  <Admin id="setting">
    <v-main>
      <v-container fluid v-if="!isProductListLoading">
        <v-row align="center" justify="center">

          <!-- userCompany {{ userCompany }} -->

          <template v-if="selectedCompanyProductList?.isPdfDoc">
            <v-col cols="12">
              <!-- Button visible to all users if isPdfDoc is true -->
              <SettingButton
                iconSrc="/images/icons/icon-setting-board.svg"
                altText="board"
                label="ปรับแต่งบอร์ด"
                :to="{ name: 'Company.Settings.Board' }"
                :isDisabled="selectedCompany.isDemo"
              />

              <!-- Buttons for owner only -->
              <template v-if="isOwnerOnly">
                <SettingButton
                  iconSrc="/images/icons/icon-setting-users.svg"
                  altText="users"
                  label="ผู้ใช้งาน"
                  :to="{ name: 'Company.Settings.Users' }"
                  :isDisabled="selectedCompany.isDemo"
                />
                <SettingButton
                  iconSrc="/images/icons/icon-setting-company.svg"
                  alt="companies"
                  label="โปรไฟล์บริษัท"
                  :to="{ name: 'Company.Settings.Company' }"
                  :isDisabled="selectedCompany.isDemo"
                />

              </template>

              <!-- Buttons for developer only -->
              <template v-if="isDeveloperOnly || user?.isEngineer">
                <SettingButton
                  iconSrc="/images/icons/icon-setting-users.svg"
                  altText="users"
                  label="ผู้ใช้งาน"
                  :to="{ name: 'Company.Settings.Users' }"
                  :isDisabled="selectedCompany.isDemo"
                />
             
                <SettingButton
                  iconSrc="/images/icons/icon-setting-company.svg"
                  alt="companies"
                  label="โปรไฟล์บริษัท"
                  :to="{ name: 'Company.Settings.Company' }"
                  :isDisabled="selectedCompany.isDemo"
                />

                <SettingButton
                  iconSrc="/images/icons/icon_auto_doc.svg"
                  alt="autoDocument"
                  label="เอกสารอัตโนมัติ"
                  :to="{ name: 'Company.Settings.AutoDoc' }"
                  :isDisabled="selectedCompany.isDemo"
                />


                <SettingButton
                  iconSrc="/images/icons/icon-setting-test.svg"
                  alt="companies"
                  label="ทดสอบ AR"
                  :to="{ name: 'Company.Settings.TestDoc' }"
                  :isDisabled="selectedCompany.isDemo"
                />

              </template>

            </v-col>
          </template>
          
          <template v-else-if="selectedCompanyProductList?.isApAutomate">
            <v-col cols="12">
              <!-- Button visible to all users if isPdfDoc is true -->
              <SettingButton
                iconSrc="/images/icons/icon-setting-board.svg"
                altText="board"
                label="ปรับแต่งบอร์ด"
                :to="{ name: 'Company.Settings.Board' }"
                :isDisabled="selectedCompany.isDemo"
              />

              <!-- Buttons for owner only -->
              <template v-if="isOwnerOnly && !user?.isEngineer">
                <SettingButton
                  iconSrc="/images/icons/icon-setting-users.svg"
                  altText="users"
                  label="ผู้ใช้งาน"
                  :to="{ name: 'Company.Settings.Users' }"
                  :isDisabled="selectedCompany.isDemo"
                />
                <SettingButton
                  iconSrc="/images/icons/icon-setting-company.svg"
                  alt="companies"
                  label="โปรไฟล์บริษัท"
                  :to="{ name: 'Company.Settings.Company' }"
                  :isDisabled="selectedCompany.isDemo"
                />

                <SettingButton
                  iconSrc="/images/icons/icon-setting-ai-master-data.svg"
                  alt="setting ai"
                  label="ข้อมูลพื้นฐาน"
                  :to="{ name: 'Company.Settings.ApAutomationMaster' }"
                  :isDisabled="selectedCompany.isDemo"
                /> 

                <SettingButton
                  iconSrc="/images/icons/icon-setting-ai-ap.svg"
                  alt="setting ai"
                  label="ผู้จำหน่าย"
                  :to="{ name: 'Company.Settings.ApAutomation' }"
                  :isDisabled="selectedCompany.isDemo"
                />
         
              </template>

              <!-- Buttons for developer only -->
              <template v-else-if="isDeveloperOnly || user?.isEngineer">
                <SettingButton
                  iconSrc="/images/icons/icon-setting-users.svg"
                  altText="users"
                  label="ผู้ใช้งาน"
                  :to="{ name: 'Company.Settings.Users' }"
                  :isDisabled="selectedCompany.isDemo"
                />

                <SettingButton
                  iconSrc="/images/icons/icon-setting-company.svg"
                  alt="companies"
                  label="โปรไฟล์บริษัท"
                  :to="{ name: 'Company.Settings.Company' }"
                  :isDisabled="selectedCompany.isDemo"
                />

            
                <SettingButton
                  iconSrc="/images/icons/icon-setting-ai-master-data.svg"
                  alt="setting ai"
                  label="ข้อมูลพื้นฐาน"
                  :to="{ name: 'Company.Settings.ApAutomationMaster' }"
                  :isDisabled="selectedCompany.isDemo"
                />  

                <SettingButton
                  iconSrc="/images/icons/icon-setting-ai-ap.svg"
                  alt="setting ai"
                  label="ผู้จำหน่าย"
                  :to="{ name: 'Company.Settings.ApAutomation' }"
                />

                <SettingButton
                  iconSrc="/images/icons/icon_auto_doc.svg"
                  alt="setting ai"
                  label="เอกสารอัตโนมัติ"
                  :to="{ name: 'Company.Settings.ApAutomationPrompt' }"
                />

                <SettingButton
                  iconSrc="/images/icons/icon-setting-test-ap.svg"
                  alt="companies"
                  label="ทดสอบAP"
                  :to="{ name: 'Company.Settings.TestDoc-AP' }"
                  :isDisabled="selectedCompany.isDemo"
                />
        
              </template>

            </v-col>
          </template>
          <template v-else>
          <v-col cols="12">
            <!-- Board -->
            <v-btn
              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Board' }"
              >
              <span class="">
                <img
                  src="/images/icons/icon-setting-board.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">ปรับแต่งบอร์ด</div>
              </span>
            </v-btn>

            <!-- Users -->
            <v-btn
              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Users' }"
              >
              <span class="">
                <img
                  src="/images/icons/icon-setting-users.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">ผู้ใช้งาน</div>
              </span>
            </v-btn>

            <!-- Packages -->
            <v-btn
            v-if="!selectedCompanyProductList?.isPdfDoc"

              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Packages' }"
            >
              <span class="">
                <img
                  src="/images/icons/icon-setting-packages.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">แพ็คเกจ</div>
              </span>
            </v-btn>

            <!-- Payments -->
            <v-btn
            v-if="!selectedCompanyProductList?.isPdfDoc"

              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Payments' }"
            >
              <span class="">
                <img
                  src="/images/icons/icon-setting-payments.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">การชำระเงิน</div>
              </span>
            </v-btn>
            
            <!-- Key -->
            <v-btn
            v-if="!selectedCompanyProductList?.isPdfDoc"

              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Keys' }"
            >
              <span class="">
                <img
                  src="/images/icons/icon-setting-keys.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">หนังสือรับรอง</div>
              </span>
            </v-btn>

            <!-- ERP -->
            <v-btn
            v-if="!selectedCompanyProductList?.isPdfDoc"

              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Erp' }"
            >
              <span class="">
                <img
                  src="/images/icons/icon-setting-erps.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">โปรแกรมบัญชี</div>
              </span>
            </v-btn>

            <!-- Company -->
            <v-btn
              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Company' }"
            >
              <span class="">
                <img
                  src="/images/icons/icon-setting-company.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">โปรไฟล์บริษัท</div>
              </span>
            </v-btn>

            <!-- Shops -->
            <v-btn
              v-if="!selectedCompanyProductList?.isPdfDoc"
              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Shops' }"
            >
              <span class="">
                <img
                  src="/images/icons/icon_menu_ecommerce.svg"
                  width="60"
                  height="60"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">
                  จัดการใบสั่งขายออนไลน์
                </div>
              </span>
            </v-btn>

            <!-- Email -->
            <v-btn
            v-if="!selectedCompanyProductList?.isPdfDoc"

              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Email' }"
            >
              <span class="">
                <img
                  src="/images/icons/icon_email_config.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">อีเมล</div>
              </span>
            </v-btn>

            <!-- setting exchange rate -->
            <v-btn
              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px" 
              link
              :to="{ name: 'Company.Settings.Exchange' }"
              v-if="selectedCompanyProductList?.isExchangeRate"
            >
              <span class="">
                <img
                  src="/images/icons/currency-exchange.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">ตั้งค่า อัตราแลกเปลี่ยน</div>
              </span>
            </v-btn>

            <!-- setting exchange rate repair -->
            <v-btn
              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px" 
              link
              :to="{ name: 'Company.Settings.ExchangeRepair' }"
              v-if="selectedCompanyProductList?.isExchangeRate && (userCompany?.isDeveloper || user?.isEngineer )"
            >
              <span class="">
                <img
                  src="/images/icons/currency-exchange-repairer.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">ช่อมอัตราแลกเปลี่ยน</div>
              </span>
            </v-btn>
            
            <!-- AutoDocumentation -->
            <v-btn
              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              link
              :to="{ name: 'Company.Settings.AutoDoc' }"
              v-if="selectedCompanyProductList?.isPdfDoc && user?.isEngineer"
            >
              <span class="">
                <img
                  src="/images/icons/icon_auto_doc.svg"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">เอกสารอัตโนมัติ</div>
              </span>
            </v-btn>
            
            <!-- Setting KBank -->
            <v-btn
              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px" 
              link
              :to="{ name: 'Company.Settings.KBank' }"
            >
              <span class="">
                <img
                  src="/images/icons/currency-exchange-repairer.svg"
                  alt="kbank"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">KBank</div>
              </span>
            </v-btn>

            <!-- Setting Branch -->
            <v-btn
              v-if="selectedCompanyProductList?.isTopserv /* TODO: remove*/"
              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Branch' }"
            >
              <span class="">
                <img
                  src="/images/icons/icon-setting-add-branch.svg"
                  width="60"
                  height="60"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">
                  จัดการสาขา
                </div>
              </span>
            </v-btn>   
            
            <!-- Setting WHT -->
            <v-btn
              v-if="selectedCompanyProductList?.isNsThaiSmartTax"
              class="ma-3 btn-border"
              color="white"
              width="190px"
              height="190px"
              :disabled="selectedCompany.isDemo"
              link
              :to="{ name: 'Company.Settings.Wht' }"
            >
              <span class="">
                <img
                  src="/images/icons/wht-setting.svg"
                  width="60"
                  height="60"
                  alt="board"
                  class="image-style"
                />
                <div style="font-size: 16px" class="mt-2">
                  ตั้งค่าภาษีหัก ณ ที่จ่าย
                </div>
              </span>
            </v-btn>


          </v-col>
          </template>

          <!-- Everyone can see -->
          <template>
            <v-col cols="12">
              <!-- Setting API -->
              <v-btn
                class="ma-3 btn-border"
                color="white"
                width="190px"
                height="190px" 
                link
                :to="{ name: 'Company.Settings.API' }"
              >
                <span class="">
                  <img
                    src="/images/icons/currency-exchange-repairer.svg"
                    alt="kbank"
                    class="image-style"
                  />
                  <div style="font-size: 16px" class="mt-2">API</div>
                </span>
              </v-btn>
            </v-col>
          </template>

        </v-row>
      </v-container>
      <v-container fluid v-else>
        <v-row align="center" >
          <v-col
            v-for="n in 4"
            :key="n"
            cols="auto"
            >
              <v-skeleton-loader
              class="mx-auto"
              height="190px"
              width="190px"
              type="card"
              ></v-skeleton-loader>
          </v-col>
        </v-row>

      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import SettingButton from "@/components/admin/settings/button-setting.vue";
import { mapState } from "vuex";
import getRole from "@/libs/getRole";


export default {
  name: "Settings",
  computed: {
    ...mapState({
      selectedCompany: (state) => state.companies.selectedCompany,
      user: (state) => state.user.userData,
      userCompany: (state) => state.user.userCompany,
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading
    }),
    
    isOwnerOnly() {
      return this.checkRole(this.userCompany) === 'owner' && !this.userCompany.isDeveloper;
    },
    isDeveloperOnly() {
      return this.checkRole(this.userCompany) === 'developer';
    }
  },
  components: {
    Admin,
    SettingButton
  },
  created() {
    this.getCompanyProductList();
    const companyID = this.$route.params.companyId;

    if (companyID) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyID });
    }
  },
  methods: {
    
    getCompanyProductList() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getCompanyProductList", { companyId });
    },
    checkRole: function (user) {
      return getRole(user)
    },
  }
  
};
</script>

<style lang="scss">
#setting {
  .btn-border {
    border-radius: 20px !important;
  }

  .image-style {
    display: block;
    margin: auto;
    max-width: 60px;
    max-height: 60px;
  }

  .mt-2 {
    font-size: 16px;
    text-align: center; /* Ensure the text is centered */
    display: block; /* Ensure proper alignment */
  }
}

.custom-skeleton {
  border-radius: 16px; 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
}
</style>
